import Styled from "styled-components";

export const OfferCard = Styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;

    .offer-card {
        border-radius: 24px;

        .offer-row {
            border-bottom: 1px solid #f0f0f0;
            padding: 12px 0;

            &:last-child {
                border-bottom: none;
            }

            .icon-col {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .info-icon {
                font-size: 18px;
                color: #1890ff;
                cursor: pointer;
                margin-left:auto;
            }

            .gift-icon {
                font-size: 18px;
                color: #52c41a;
            }

            .offer-mode {
                font-weight: 600;
            }

            .cashback-text {
                color: #52c41a;
                font-weight: 500;
            }

            .price-text {
                color: #ff4d4f;
                font-weight: 500;
            }
        }
    }

`;

export const PptData = Styled.div`
.ppt_view_details iframe{
    height:400px
}`;

export const getShelfLabelPrintStyles = ({ pageSize, printableSize }) => `
    .shelf-label-print-page {
        width: ${pageSize.width}in;
        height: ${pageSize.height}in;
        padding: ${pageSize.padding}in;
        background: #ffffff;
        box-sizing: border-box;
        margin: 0 auto 18px;
        box-shadow: 0 20px 55px rgba(15, 23, 42, 0.18);
    }

    .shelf-label-print-page-inner {
        position: relative;
        width: ${printableSize.width}in;
        height: ${printableSize.height}in;
    }

    .shelf-label-print-slot {
        position: absolute;
        box-sizing: border-box;
        overflow: hidden;
        break-inside: avoid;
        page-break-inside: avoid;
    }

    @media print {
        @page {
            size: A4 ${pageSize.orientation};
            margin: 0;
        }

        html,
        body {
            background: #ffffff !important;
            height: auto !important;
            margin: 0 !important;
            overflow: visible !important;
            width: auto !important;
        }

        body.shelf-label-printing > #root {
            display: none !important;
        }

        body * {
            visibility: hidden;
        }

        .ant-modal-root,
        .ant-modal-wrap,
        .ant-modal,
        .ant-modal-content,
        .ant-modal-body {
            background: #ffffff !important;
            box-shadow: none !important;
            height: auto !important;
            inset: auto !important;
            margin: 0 !important;
            max-height: none !important;
            max-width: none !important;
            overflow: visible !important;
            padding: 0 !important;
            position: static !important;
            transform: none !important;
            visibility: visible !important;
            width: auto !important;
        }

        .ant-modal-mask,
        .ant-modal-header,
        .ant-modal-footer,
        .ant-modal-close {
            display: none !important;
        }

        .shelf-label-print-root,
        .shelf-label-print-root * {
            visibility: visible;
        }

        .shelf-label-print-root {
            background: #ffffff;
            display: block !important;
            height: auto !important;
            overflow: visible !important;
            position: static !important;
            width: auto !important;
        }

        .shelf-label-print-page {
            width: ${pageSize.width}in;
            height: ${pageSize.height}in;
            padding: ${pageSize.padding}in;
            margin: 0;
            box-shadow: none;
            break-after: page;
            page-break-after: always;
        }

        .shelf-label-print-page:last-child {
            break-after: auto;
            page-break-after: auto;
        }

        .shelf-label-print-meta {
            display: none !important;
        }

        * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
        }

        .shelf-label-print-alert{
            display: none !important;
        }
    }
`;
